import { render, staticRenderFns } from "./CarouselNumbersAdmin.vue?vue&type=template&id=83ef39fc&scoped=true"
import script from "./CarouselNumbersAdmin.vue?vue&type=script&lang=js"
export * from "./CarouselNumbersAdmin.vue?vue&type=script&lang=js"
import style0 from "./CarouselNumbersAdmin.vue?vue&type=style&index=0&id=83ef39fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ef39fc",
  null
  
)

export default component.exports